import React from "react";
import { MapPin, Building2, HeartPulse, ArrowLeft } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function LocationsAndPavilionsInNetanya() {
  return <section id="מיקומים-וביתנות-בנתניה" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center mb-12">
          <div className="inline-flex items-center justify-center p-3 bg-primary/10 rounded-lg mb-4">
            <MapPin className="w-6 h-6 text-primary" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4">
            בתי חולים בנתניה: המרכז הרפואי לניאדו
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl">
            שירותי סיעוד והשגחה פרטית מותאמים אישית למאושפזים בבית החולים לניאדו.
          </p>
        </div>

        <Card className="overflow-hidden border-border shadow-md">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="p-8 md:p-12 flex flex-col justify-center">
              <div className="flex items-center gap-3 mb-6">
                <Building2 className="w-6 h-6 text-primary" />
                <h3 className="text-2xl font-semibold font-default text-foreground">
                  נוכחות מקצועית ומרגיעה
                </h3>
              </div>
              <div className="space-y-4 text-muted-foreground leading-relaxed">
                <p>
                  בית החולים לניאדו, הממוקם בקריית צאנז בנתניה, הוא המרכז הרפואי המרכזי המשרת את תושבי העיר והסביבה. בית החולים נוסד מתוך חזון של חסד ונתינה, ומעניק שירותי רפואה מתקדמים באווירה תומכת ומקצועית.
                </p>
                <p>
                  אנו מספקים שירותי סיעוד והשגחה פרטית למטופלים המאושפזים במחלקות השונות של בית החולים לניאדו. הצוות המיומן שלנו זמין להעניק טיפול אישי, מסור וצמוד, תוך שיתוף פעולה מלא עם הצוות הרפואי של בית החולים.
                </p>
                <p>
                  בין אם מדובר בהשגחה לאחר ניתוח, סיוע סיעודי במהלך אשפוז ממושך, או ליווי צמוד בשעות הלילה, המטפלים שלנו נמצאים שם כדי להבטיח את הנוחות והבטיחות המרבית של יקיריכם. אנו מבינים את החשיבות של נוכחות מרגיעה ומקצועית בסביבה הבית חולימית, ופועלים כדי להקל על המטופל ועל בני משפחתו בתקופה המאתגרת של האשפוז.
                </p>
              </div>

              <div className="mt-8 flex flex-col sm:flex-row gap-4">
                <Link to="/NursingCareNowPage">
                  <Button size="lg" className="w-full sm:w-auto gap-2">
                    <HeartPulse className="w-5 h-5" />
                    הזמן שירותי סיעוד בלניאדו
                  </Button>
                </Link>
                <Link to="/ContactPage">
                  <Button variant="outline" size="lg" className="w-full sm:w-auto gap-2">
                    צור קשר לייעוץ
                    <ArrowLeft className="w-4 h-4" />
                  </Button>
                </Link>
              </div>
            </div>

            <div className="relative h-full min-h-[300px] lg:min-h-full bg-muted">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/laniado_hospital_care_netanya.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/laniado_hospital_care_netanya.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/laniado_hospital_care_netanya.png-wvc-sizes" alt="שירותי סיעוד בבית חולים לניאדו נתניה" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
            </div>
          </div>
        </Card>
      </div>
    </section>;
}